import { createAction } from 'redux-act';

import { AnyReservation } from '../../../models/interfaces/reservation/Reservation';
import LayoutPayload from './LayoutPayload';

export interface DeleteLayoutPayload extends LayoutPayload {
  placeUuid: string;
}
export const deleteLayout = createAction<DeleteLayoutPayload>('DELETE_LAYOUT');

export interface LayoutDeletedPayload extends LayoutPayload {
  affectedReservations: AnyReservation[];
}
export const layoutDeleted = createAction<LayoutDeletedPayload>('LAYOUT_DELETED');

export type LayoutDeleteFailedPayload = LayoutPayload;
export const layoutDeleteFailed = createAction<LayoutDeleteFailedPayload>('LAYOUT_DELETE_FAILED');
